import { FunnelTableData } from "../types";

export interface PieDiagramDataItem {
  label: string;
  value: number;
  color: string;
  type_ids: number[];
}

export interface PieChartProps {
  data: PieDiagramDataItem[];
  size?: number;
  splitPractice?: boolean;
}

export interface ProgressBarProps {
    fact: number; // Значение от 0 до 100
    target: number;
    startDate: string; // Начальная дата
    endDate: string; // Конечная дата
}

export interface ProgressBarPropsPeople {
  fact: number; // Значение от 0 до 100
  employ: number;
  unemploy: number;
  updated: number;
}

export const eventTypeColors = {
  "11": "#FF5733", // Звонок
  "12": "#30C6F6", // Консультация
  "13": "#FFA902", // Практика 1
  "14": "#FFBF43", // Практика 2
  "15": "#FFCF53", // Практика 3
  "16": "#FFE266", // Практика 4
  "17": "#FFB994", // Практика 5
  "18": "#FFA474", // Практика 6
  "19": "#FF8C50", // Практика 7
  "20": "#FF8C50", // Практика 8
  "21": "#FF7D38", // Практика 9
  "22": "#FFA902", // Практика 10
  "23": "#FFA902", // Вопрос о счете
  "24": "#33F5FF", // В поиске
  "25": "#FF7700", // Открытие счёта
  "26": "#FF4D00", // Последующее пополнение
  "27": "#FF5733", // Мастер класс
  "28": "#33FF57", // Встреча
  "29": "#3357FF", // Собеседование на менеджера
  "30": "#FF33A1", // Собеседование на оператора
  "31": "#33FFF5", // Стажировка менеджеров
  "32": "#F5FF33", // Стажировка операторов
  "5":"#56D0E1", // Сумма по практикам
  "1": "#3AA8EF",  // Регистрация
};

export const roleTypeColors = [
  "#3AA8EF", "#30C6F6", "#56D0E1", "#FFA902", "#FF7700"
]

export const tiimePeriods = ['last30days', 'lastYear', 'sinceStartOfYear']


export const monthNames = [
  "Январь",
  "Февраль",
  "Март",
  "Апрель",
  "Май",
  "Июнь",
  "Июль",
  "Август",
  "Сентябрь",
  "Октябрь",
  "Ноябрь",
  "Декабрь",
];

